function Ctrl($rootScope, $scope, jsSdkSettings, utilsService) {
  $scope.referralGetCredit = 25;
  $scope.referralGiveCredit = 25;

  $scope.currentUser = $rootScope.currentUser;

  const referralCode = ($scope.currentUser && $scope.currentUser.referralCode) ? $scope.currentUser.referralCode : '';

  $scope.shareBarConfig = {
    url: utilsService.createUrl(`/invite/${referralCode}`),
    message: 'Join @Tablelist with my promo code to get credit at your favorite clubs and lounges.'
  };

  jsSdkSettings.readConfig()
    .then(function success(resp) {
      $scope.referralGetCredit = resp.referralGetCredit;
      $scope.referralGiveCredit = resp.referralGiveCredit;
      $scope.shareBarConfig.message = `Join @Tablelist with my promo code to get $${resp.referralGiveCredit} in credit at your favorite clubs and lounges.`;
    });
}

Ctrl.$inject = [
  '$rootScope',
  '$scope',
  'jsSdk.settings',
  'utilsService'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/directives/referralBlock/controller.js